"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toVar = exports.toSelector = void 0;
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var toSelector = function (rule) { return ".".concat(rule.split(" ").filter(Boolean).join(".")); };
exports.toSelector = toSelector;
var toVar = function (varFunction) {
    var matches = varFunction.match(/var\((--[^,)]+)\)/);
    (0, tiny_invariant_1.default)(!!matches, "".concat(varFunction, " wasn't in the expected format"));
    var varString = matches[1];
    (0, tiny_invariant_1.default)(!!varString, "Couldn't extract variable name from ".concat(varFunction));
    return varString;
};
exports.toVar = toVar;
